import React from "react";

export function FixedIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 70 70"
      width="30"
      height="30"
      {...props}
    >
      <g id="icons">
        <g id="fixed_bold" data-name="fixed bold">
          <path
            className="cls-1"
            d="m61.37,70H8.63c-4.76,0-8.63-3.87-8.63-8.63V8.63C0,3.87,3.87,0,8.63,0h52.75c4.76,0,8.63,3.87,8.63,8.63v52.75c0,4.76-3.87,8.63-8.63,8.63ZM8.63,3.11c-3.04,0-5.52,2.48-5.52,5.52v52.75c0,3.04,2.48,5.52,5.52,5.52h52.75c3.04,0,5.52-2.48,5.52-5.52V8.63c0-3.04-2.48-5.52-5.52-5.52H8.63Z"
          />
          <rect
            className="cls-1"
            x="15.51"
            y="33.92"
            width="38.35"
            height="3.11"
          />
          <rect
            className="cls-1"
            x="15.51"
            y="41.73"
            width="38.35"
            height="3.11"
          />
          <rect
            className="cls-1"
            x="15.51"
            y="49.54"
            width="38.35"
            height="3.11"
          />
          <path
            className="cls-1"
            d="m47.28,30.26h-3.11v-6.32c0-3.04-2.48-5.52-5.52-5.52h-7.93c-3.04,0-5.52,2.48-5.52,5.52v6.32h-3.11v-6.32c0-4.76,3.87-8.63,8.63-8.63h7.93c4.76,0,8.63,3.87,8.63,8.63v6.32Z"
          />
        </g>
      </g>
    </svg>
  );
}
